import * as React from "react";
import type { SVGProps } from "react";
const SvgIconWasherDryer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.43.83c-1.02.17-1.83.99-2.01 2-.05.27-.05 18.07 0 18.34.18 1.02 1 1.83 2.02 2 .2.03 1.14.04 7.56.04 7.98 0 7.55 0 7.95-.13.22-.08.53-.25.71-.38.32-.25.62-.64.77-1.03.1-.24.14-.4.17-.7.03-.37.03-17.57 0-17.93-.03-.3-.07-.47-.17-.71-.32-.8-1.04-1.37-1.87-1.5-.2-.03-1.13-.04-7.58-.04-6.03 0-7.4.01-7.55.04m.17 1.72q-.33.13-.45.44c-.04.13-.05.19-.05 1.35v1.23h15.8V4.34c0-1.17 0-1.22-.05-1.35q-.1-.26-.35-.4l-.12-.06h-7.36c-5.6 0-7.37 0-7.42.02M4.1 14.1c0 6.77 0 6.79.05 6.92.06.16.2.32.35.4l.12.06h14.76l.12-.06q.24-.14.35-.4c.05-.13.05-.15.05-6.92v-6.8H4.1zm7.38-5.32Q9.45 9 8.03 10.4q-.67.66-1.07 1.48c-.83 1.64-.79 3.6.1 5.22.85 1.53 2.33 2.57 4.09 2.86.2.03.4.04.85.04s.65 0 .85-.04c1.84-.3 3.37-1.42 4.2-3.06q.41-.86.55-1.83c.03-.28.03-1.1 0-1.37q-.16-1.1-.66-2.01c-.26-.49-.56-.88-.98-1.3q-1.26-1.25-3.04-1.56c-.22-.04-.4-.05-.81-.06zm.3 1.7c-.47.05-.87.14-1.28.3-.85.35-1.58 1.03-1.99 1.85l-.06.12h.33c1.17 0 2.32.28 3.55.85q.63.3 1.01.42 1 .32 2.18.32h.4v-.12c0-.16-.07-.57-.13-.8-.26-1.01-.93-1.9-1.86-2.43-.38-.21-.95-.41-1.37-.46-.23-.03-.63-.05-.78-.04m-3.7 4.1c0 .16.07.56.13.8.3 1.17 1.17 2.17 2.29 2.63.5.2.92.3 1.48.3s1-.09 1.52-.3c.85-.34 1.58-1.02 1.99-1.84l.06-.13h-.33c-.41 0-.78-.03-1.25-.1-.8-.14-1.45-.35-2.3-.75q-.63-.3-1.01-.42-1-.3-2.18-.31h-.4z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconWasherDryer;
